import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader, Field, Select, Toggle, ConfirmDeleteButton } from "./_helpers";
import MediaPicker from "@/components/admin/MediaPicker";
import { toast } from "sonner";

export default function AdminAds() {
  const [zones, setZones] = useState([]);
  const [ads, setAds] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [tab, setTab] = useState("zones");
  const emptyZ = { name: "", slug: "", page_position: "", width: 728, height: 90, mobile_width: 320, mobile_height: 100, daily_price: 0, weekly_price: 0, monthly_price: 0, formats: ["jpg", "png", "gif"], is_active: true };
  const emptyA = { zone_id: "", name: "", image: "", link: "", target_province_id: "", daily_price: 0, is_active: true };
  const [zf, setZf] = useState(emptyZ);
  const [af, setAf] = useState(emptyA);
  const load = () => { api.get("/ad-zones").then((r) => setZones(r.data)); api.get("/ads?is_active=true&limit=100").then((r) => setAds(r.data)); };
  useEffect(() => { load(); api.get("/provinces?active_only=false").then((r) => setProvinces(r.data)); }, []);
  const saveZ = async () => { try { await api.post("/ad-zones", zf); setZf(emptyZ); load(); toast.success("Eklendi"); } catch { toast.error("Hata"); } };
  const saveA = async () => { try { await api.post("/ads", { ...af, target_province_id: af.target_province_id || null }); setAf(emptyA); load(); toast.success("Eklendi"); } catch { toast.error("Hata"); } };

  return (
    <div>
      <AdminPageHeader title="Reklam Yönetimi" />
      <div className="flex gap-2 mb-4">
        <button onClick={() => setTab("zones")} className={`px-3 py-1.5 rounded text-sm ${tab === "zones" ? "bg-[#e11d2a] text-white" : "border"}`}>Alanlar</button>
        <button onClick={() => setTab("ads")} className={`px-3 py-1.5 rounded text-sm ${tab === "ads" ? "bg-[#e11d2a] text-white" : "border"}`}>Kampanyalar</button>
      </div>
      {tab === "zones" ? (
        <div className="grid lg:grid-cols-2 gap-4">
          <div className="bg-white border border-gray-100 rounded-lg p-4 max-h-[500px] overflow-y-auto">
            {zones.map((z) => (
              <div key={z.id} className="py-2 border-b flex items-center justify-between">
                <div><div className="font-semibold text-sm">{z.name} <span className="text-xs text-gray-400">({z.slug})</span></div><div className="text-xs text-gray-500">{z.width}×{z.height} - Mobil: {z.mobile_width}×{z.mobile_height} - Günlük: {z.daily_price}₺</div></div>
                <ConfirmDeleteButton onConfirm={async () => { await api.delete(`/ad-zones/${z.id}`); load(); }} />
              </div>
            ))}
          </div>
          <div className="bg-white border border-gray-100 rounded-lg p-4 space-y-2">
            <h3 className="font-bold">Yeni Alan</h3>
            <Field label="Ad" value={zf.name} onChange={(e) => setZf({ ...zf, name: e.target.value })} />
            <Field label="Slug" value={zf.slug} onChange={(e) => setZf({ ...zf, slug: e.target.value })} />
            <Field label="Sayfa Konumu" value={zf.page_position} onChange={(e) => setZf({ ...zf, page_position: e.target.value })} />
            <div className="grid grid-cols-2 gap-2">
              <Field label="Genişlik" type="number" value={zf.width} onChange={(e) => setZf({ ...zf, width: +e.target.value })} />
              <Field label="Yükseklik" type="number" value={zf.height} onChange={(e) => setZf({ ...zf, height: +e.target.value })} />
              <Field label="Mobil G" type="number" value={zf.mobile_width} onChange={(e) => setZf({ ...zf, mobile_width: +e.target.value })} />
              <Field label="Mobil Y" type="number" value={zf.mobile_height} onChange={(e) => setZf({ ...zf, mobile_height: +e.target.value })} />
              <Field label="Günlük ücret" type="number" value={zf.daily_price} onChange={(e) => setZf({ ...zf, daily_price: +e.target.value })} />
              <Field label="Aylık ücret" type="number" value={zf.monthly_price} onChange={(e) => setZf({ ...zf, monthly_price: +e.target.value })} />
            </div>
            <button onClick={saveZ} className="w-full px-4 py-2 bg-[#e11d2a] text-white rounded text-sm font-semibold">Ekle</button>
          </div>
        </div>
      ) : (
        <div className="grid lg:grid-cols-2 gap-4">
          <div className="bg-white border border-gray-100 rounded-lg p-4 max-h-[500px] overflow-y-auto">
            {ads.map((a) => (
              <div key={a.id} className="py-2 border-b flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <img src={a.image} alt="" className="w-12 h-8 object-cover rounded" />
                  <div><div className="font-semibold text-sm">{a.name}</div><div className="text-xs text-gray-500">{a.impressions || 0} gösterim • {a.clicks || 0} tıklama</div></div>
                </div>
                <ConfirmDeleteButton onConfirm={async () => { await api.delete(`/ads/${a.id}`); load(); }} />
              </div>
            ))}
          </div>
          <div className="bg-white border border-gray-100 rounded-lg p-4 space-y-2">
            <h3 className="font-bold">Yeni Kampanya</h3>
            <Select label="Alan" value={af.zone_id} options={[{ value: "", label: "-" }, ...zones.map((z) => ({ value: z.id, label: z.name }))]} onChange={(e) => setAf({ ...af, zone_id: e.target.value })} />
            <Field label="Ad" value={af.name} onChange={(e) => setAf({ ...af, name: e.target.value })} />
            <div>
              <label className="block text-xs font-medium mb-1 text-gray-600">Görsel</label>
              <MediaPicker
                value={af.image}
                onChange={(u) => setAf({ ...af, image: u })}
                scope="ads"
                testId="ads-image-picker"
              />
            </div>
            <Field
              label="Link"
              value={af.link}
              onChange={(e) => setAf({ ...af, link: e.target.value })}
              placeholder="https://www.ornek.com"
            />
            <p className="text-[10px] text-gray-500 -mt-1">
              💡 Tam URL yazın (örn. <code>https://www.ornek.com</code>). Eğer <code>https://</code> yazmazsanız sistem
              otomatik olarak ekler — yine de bağlantının doğru çalışması için tam URL girmenizi öneririz.
            </p>
            <Select label="Hedef İl" value={af.target_province_id || ""} options={[{ value: "", label: "Tümü" }, ...provinces.map((p) => ({ value: p.id, label: p.name }))]} onChange={(e) => setAf({ ...af, target_province_id: e.target.value })} />
            <Field label="Günlük ücret" type="number" value={af.daily_price} onChange={(e) => setAf({ ...af, daily_price: +e.target.value })} />
            <button onClick={saveA} className="w-full px-4 py-2 bg-[#e11d2a] text-white rounded text-sm font-semibold">Oluştur</button>
          </div>
        </div>
      )}
    </div>
  );
}
